import {StackItem} from '../../interfaces/router/stackItem';
import screens from '../../config/screens';
import HomeDrawer from '../drawer';
import AddNote from '../../screens/content/notes/addNote';
import ViewNote from '../../screens/content/notes/viewNote';
import LatestArticle from '../../screens/content/latestArticle';
import ForYou from '../../screens/content/forYou';
import FileViewer from '../../screens/content/fileViewer';
import Calculators from '../../screens/content/calculators';
import Summaries from '../../screens/content/summaries';
import AfterLogin from '../../screens/auth/afterLogin';
import {createLazyComponent} from '../../utils/lazyLoad';

// Create lazy loaded components
const LazyHomeDrawer = createLazyComponent(HomeDrawer);
const LazyAddNote = createLazyComponent(AddNote);
const LazyViewNote = createLazyComponent(ViewNote);
const LazyFileViewer = createLazyComponent(FileViewer);
const LazyCalculators = createLazyComponent(Calculators);
const LazyLatestArticle = createLazyComponent(LatestArticle);
const LazyForYou = createLazyComponent(ForYou);
const LazySummaries = createLazyComponent(Summaries);
const LazyAfterLogin = createLazyComponent(AfterLogin);

/**
 * An array of shared routes for a navigation stack.
 * @type {StackItem[]}
 */
const contentRoutes: StackItem[] = [
  {
    name: screens.homeDrawer,
    component: LazyHomeDrawer,
    options: {
      headerShown: false,
    },
  },
  {
    name: screens.content.addNote,
    component: LazyAddNote,
  },
  {
    name: screens.content.viewNote,
    component: LazyViewNote,
  },
  {
    name: screens.content.fileViewer,
    component: LazyFileViewer,
  },
  {
    name: screens.content.calculators,
    component: LazyCalculators,
  },
  {
    name: screens.content.latestArticle,
    component: LazyLatestArticle,
  },
  {
    name: screens.content.news,
    component: LazyForYou,
    options: {},
  },
  {
    name: screens.content.summaries,
    component: LazySummaries,
  },
  {
    name: screens.content.afterLogin,
    component: LazyAfterLogin,
    options: {
      animation: 'none',
      gestureEnabled: false,
    },
  },
];
export default contentRoutes;
